import { IconAngleRight, IconCautionTriangle, IconCheckmarkCircle } from '@ace/react-icons';
import CardHeader from '../CardHeader';
import CardLink from 'Components/Card/CardLink';
import { courseHelpers } from 'Components/Card/Partials/Partials.Course';
import styles from 'assets/css/NPCertificationExam.module.css';
import buttonStyles from 'assets/css/Button.module.css';
import npImg from 'assets/images/non-proctored-cert-exam-icon.svg';
import { format } from 'date-fns';
import { getUTCDateFromServerDate } from 'utils/dateUtils';
import CoursePartials from "../Partials/Partials.Course";


function NonProctoredExamCard (props) {
    const courseState = props.data ?? props;
    const courseTitle = courseState.Title ?? courseState.title;
    const nonProctorHeaderProps = {
        "componentName": props.Type,
        "type": props.Type,
        "cardIconKey": props.Type,
        "draggable": false,
        "cardTitle": props.headerText,
    }

    return (
        <div>
            { !!props.cardTools && <CardHeader {...nonProctorHeaderProps} cardTools={props.cardTools} />}

            <h3 className={styles.title}>
                {courseTitle}
            </h3>
            
            {courseState.UpgradeRequired && courseState.UpgradeText && <UpgradeRequired course={courseState} />}
            {!courseState.UpgradeRequired && !courseState.Taken && <GetStarted course={courseState} />}
            {!courseState.UpgradeRequired && courseState.Taken && (
                courseState.Passed
                    ? <Passed course={courseState} />
                    : <Failed course={courseState} />
            )}
        </div>
    )
}

const UpgradeRequired = ({ course }) => {
    return (
        <div className={styles.getUpgradeRequired}>
            <CoursePartials.Upgrade upgradeText={course.UpgradeText} upgradeIcon={course.UpgradeIcon}/>
            <CoursePartials.CardLink {...course} />
        </div>
    )
}

const GetStarted = ({ course }) => {
    return (
        <div className={styles.getStartedContainer}>
            <p className={styles.description}>Included with your Study Program. Unlimited attempts.</p>
            <CardLink
                linkText={course.ActionLink.CardLinkText}
                linkIcon={<IconAngleRight />}
                linkUrl={course.ActionLink.CardLinkUri}
                target="_blank"
                className={`${courseHelpers.cardLinkBtnClass(course)}`}
            />
        </div>
    )
}

const Passed = ({ course }) => {
    return (
        <div className={styles.passedContainer}>
            <div className={styles.passedContent}>
                <div className={styles.passedCertRow}>
                    <img className={styles.passedCertImg} src={npImg} alt="Certification Icon" />

                    <div>
                        <h4 className={styles.passedTitle}>Congratulations! You Passed!</h4>

                        {course.HasCPR ?  (
                            <CardLink
                                linkText={course.CertificateActionLink.CardLinkText}
                                linkIcon={<IconAngleRight />}
                                linkUrl={course.CertificateActionLink.CardLinkUri}
                                target="_blank"
                                className={`${courseHelpers.cardLinkBtnClass(course)}`}
                            />
                        ) : (
                            <div className={`${courseHelpers.cardLinkBtnClass(course)} ${styles.certificateButtonDisabled}`}>
                                {course.CertificateActionLink.CardLinkText} <IconAngleRight fill="#63666A" />
                            </div>
                        )}
                    </div>
                </div>

                {!course.HasCPR && (
                    <div className={`${styles.missingCPR}`}>
                        <IconCautionTriangle className={styles.missingCPRIcon} />
                        <p className={styles.missingCPRText}>
                            CPR INFORMATION MISSING<br />
                            CPR must be completed and information uploaded before receiving the Non-Proctored Certificate.
                        </p>
                    </div>
                )}
            </div>

            <div className={styles.examResults}>
                <div className={styles.examResultsLeft}>
                    <p className={styles.examCompletionDate}>Completed {format(getUTCDateFromServerDate(course.CompletionDate), 'MMM dd, yyyy')}</p>

                    <CardLink
                        linkText={course.ActionLink.CardLinkText}
                        linkIcon={<IconAngleRight />}
                        linkUrl={course.ActionLink.CardLinkUri}
                        target="_blank"
                        className={buttonStyles.floating}
                    />
                </div>

                <div className={styles.examResultsRight}>
                    <div className={`${styles.examResultStatus} ${styles.passed}`}>
                        <IconCheckmarkCircle className={styles.examResultStatusIcon} />
                        <span className={styles.examResultsText}>Pass</span>
                    </div>
                    <div className={styles.examScore}>Score: {course.ExamScore}</div>
                </div>
            </div>
        </div>
    )
}

const Failed = ({ course }) => {
    return (
        <div className={styles.failedContainer}>
            <div className={styles.examResults}>
                <div className={styles.examResultsLeft}>
                    <p className={styles.examCompletionDate}>Completed {format(getUTCDateFromServerDate(course.CompletionDate), 'MMM dd, yyyy')}</p>

                </div>

                <div className={styles.examResultsRight}>
                    <div className={`${styles.examResultStatus} ${styles.failed}`}>
                        <IconCautionTriangle className={styles.examResultStatusIcon} />
                        <span className={styles.examResultsText}>Did Not Pass</span>
                    </div>
                    <div className={styles.examScore}>Score: {course.ExamScore}</div>
                </div>
            </div>

            <div className={styles.retakeBtnWrap}>
                <CardLink
                    linkText="Retake"
                    linkIcon={<IconAngleRight />}
                    linkUrl={course.ActionLink.CardLinkUri}
                    target="_blank"
                    className={courseHelpers.cardLinkBtnClass(course)}
                />
            </div>
        </div>
    )
}

export default NonProctoredExamCard;
